<template>
    <v-card class="ma-4">
        <v-card-title class="text-h5 bg-grey-lighten-2" primary-title>
            Create Tasks from Task Groups
        </v-card-title>

        <v-card-text>
            <v-data-table
                :headers="taskHeaders"
                :items="taskItems"
                no-results-text="No tasks."
                item-key="id"
                class="elevation-1"
                :items-per-page="25"
            >
            </v-data-table>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="cancel"> Cancel </v-btn>
            <v-btn color="primary" @click="save"> Save </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import { defineComponent } from "vue";

import { withLoadingScreen } from "@/lib/loading";
import { buildDataCollectionTasksAPIForExperiment } from "@/services/api.services.ts";
import {
    buildTaskFilterDisplay,
    findTaskDayInTaskGroups,
    findTaskGroupById,
    getDateFromExperimentStartDateForDay,
} from "@/lib/taskUtils";

export default defineComponent({
    props: {
        taskGroups: {
            type: Array,
            required: true,
        },
        readoutGroups: {
            type: Array,
            required: true,
        },
        experiment: {
            type: Object,
            required: true,
        },
        protocol: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            tasks: [],
            taskItems: [],
            taskHeaders: [
                {
                    title: "Task Group",
                    value: "taskGroup",
                    align: "left",
                    sortable: true,
                    width: "20%",
                },
                {
                    title: "Readout Group",
                    value: "readoutGroup",
                    align: "left",
                    sortable: true,
                    width: "20%",
                },
                {
                    title: "Filter",
                    value: "filter",
                    align: "left",
                    sortable: true,
                    width: "15%",
                },
                {
                    title: "Day",
                    value: "day",
                    align: "left",
                    sortable: true,
                    width: "5%",
                },
                {
                    title: "Date",
                    value: "date",
                    align: "left",
                    sortable: true,
                    width: "10%",
                },
            ],
        };
    },

    mounted() {
        this.dataCollectionTasksAPI = buildDataCollectionTasksAPIForExperiment(
            this.experiment.code
        );
    },

    methods: {
        updated() {
            withLoadingScreen(async () => {
                this.tasks = await this.dataCollectionTasksAPI.buildTasksFromTaskGroups();
                this.taskItems = this.tasks.map((task) => {
                    const taskGroup = findTaskGroupById(task.taskGroupId, this.taskGroups);
                    const readoutGroup = findTaskGroupById(task.readoutGroupId, this.readoutGroups);
                    const day = findTaskDayInTaskGroups(
                        task,
                        this.taskGroups,
                        this.experiment.day0
                    );
                    const date = getDateFromExperimentStartDateForDay(this.experiment.day0, day);
                    const taskFilterDisplay = buildTaskFilterDisplay(
                        task,
                        readoutGroup,
                        this.experiment,
                        this.protocol
                    );

                    return {
                        ...task,
                        day,
                        date,
                        filter: taskFilterDisplay,
                        taskGroup: taskGroup.name,
                        readoutGroup: readoutGroup.name,
                    };
                });
            });
        },
        async save() {
            await withLoadingScreen(async () => {
                const savedTasks = await this.dataCollectionTasksAPI.bulkSave(this.tasks);
                this.$emit("saved", savedTasks);
            });
        },
        cancel() {
            this.$emit("closed");
        },
        close() {
            this.$emit("closed");
        },
    },
});
</script>
